export default __webpack_public_path__ + "static/media/KBM04524.4b7cee8e.webp";